export default __webpack_public_path__ + "static/media/backyard4.bb64af75.jpg";